var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames, cn } from '@shapeable/utils';
var cls = classNames('highlighter');
import { breakpoints, theme } from '@shapeable/theme';
import CoreHighlighter from 'react-highlight-words';
export var HighlighterDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    .", " {\n      /* background-color: ", "; */\n      color: ", ";\n    }\n  "], ["\n    .", " {\n      /* background-color: ", "; */\n      color: ", ";\n    }\n  "])), cn('highlight'), theme.COLOR('primary'), theme.COLOR('primary'))
});
// -------- Components -------->
var My = {
  Container: styled(CoreHighlighter)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var Highlighter = function (props) {
  var className = props.className,
    rest = __rest(props, ["className"]);
  return React.createElement(My.Container, __assign({}, rest, {
    highlightClassName: cn('highlight'),
    className: cls.name(className)
  }));
};
Highlighter.defaultProps = HighlighterDefaultProps;
Highlighter.cls = cls;
var templateObject_1, templateObject_2;